import React, { useEffect } from "react";
import SalesCategorySummary from '../components/SalesCategorySummary';
import TodaySalesList from "../components/TodaySalesList";
import TodayStockInList from "../components/TodayStockInList";
import SchedulePanel from "../components/SchedulePanel";
import GlobalChatPanel from '../components/GlobalChatPanel';
import { useAuthContext } from "../context/AuthContext"; 
import "../styles/Home.css";

function Home() {
const { user: userInfo, loading } = useAuthContext(); // Contextから取得

  useEffect(() => {
    document.body.classList.add("home-page");

    return () => {
      document.body.classList.remove("home-page");
    };
  }, []);

  if (loading) return <div>読み込み中...</div>;
  if (!userInfo) return <div>ログインしていません</div>; // null対策


  return (
    <>

      <div className='home_main_container'>
        <div className='home_main_1-a'>
          <SalesCategorySummary storeId={userInfo.store_id} />
        </div>

        <div className='home_main_1-b'>
          <TodaySalesList storeId={userInfo.store_id} />
        </div>

        {/* 入庫した商品 */}
        <div className='home_main_1-c'>
          <TodayStockInList storeId={userInfo.store_id} />
        </div>

        <div className='home_main_2-a'>
          <SchedulePanel storeId={userInfo.store_id} />
        </div>

        <div className='home_main_chat'>
          <GlobalChatPanel />
        </div>
      </div>

    </>     
  
  
  



  );
}

export default Home;

